if (!customElements.get('mobile-cart-bar')) {
  customElements.define(
    'mobile-cart-bar',
    class MobileCartBar extends HTMLElement {
      constructor() {
        super();
        this.mobileMedia = window.matchMedia('(max-width: 749px)');
        this.cartFooter = this.closest('#main-cart-footer');
        this.price = this.querySelector('[data-mobile-cart-total]');
        this.button = this.querySelector('[data-mobile-cart-checkout]');
      }

      connectedCallback() {
        if (!this.cartFooter || !this.mainButton || !this.button) return;

        this.button.addEventListener('click', this.handleStickyCheckout);
        this.mobileMedia.addEventListener('change', this.handleViewportChange);

        this.cartObserver = new MutationObserver(() => this.syncFromCart());
        this.cartObserver.observe(this.cartFooter, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['class', 'disabled', 'aria-disabled'],
        });

        this.observeMainButton();
        this.syncFromCart();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleStickyCheckout);
        this.mobileMedia?.removeEventListener('change', this.handleViewportChange);
        this.cartObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        document.documentElement.classList.remove('mobile-cart-sticky-visible');
      }

      get mainButton() {
        return this.cartFooter?.querySelector('#checkout');
      }

      observeMainButton() {
        const mainButton = this.mainButton;
        if (!mainButton) return;

        const rect = mainButton.getBoundingClientRect();
        const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
        this.mainButtonVisible = visibleHeight / Math.max(rect.height, 1) >= 0.35;

        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => {
            this.mainButtonVisible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
            this.updateVisibility();
          },
          { threshold: [0, 0.35, 1] }
        );
        this.visibilityObserver.observe(mainButton);
      }

      syncFromCart() {
        const mainButton = this.mainButton;
        if (!mainButton) return;

        const currentTotal = this.cartFooter.querySelector('.totals__total-value')?.textContent.trim();
        if (currentTotal && this.price?.textContent.trim() !== currentTotal) this.price.textContent = currentTotal;

        const disabled =
          this.cartFooter.classList.contains('is-empty') ||
          mainButton.disabled ||
          mainButton.getAttribute('aria-disabled') === 'true';
        if (this.button.disabled !== disabled) this.button.disabled = disabled;

        const mainLabel = mainButton.textContent.trim();
        if (mainLabel && this.button.textContent.trim() !== mainLabel) this.button.textContent = mainLabel;

        this.updateVisibility();
      }

      updateVisibility() {
        const shouldShow = this.mobileMedia.matches && !this.button.disabled && !this.mainButtonVisible;
        this.hidden = !shouldShow;
        document.documentElement.classList.toggle('mobile-cart-sticky-visible', shouldShow);
      }

      handleStickyCheckout = () => {
        if (this.button.disabled) return;
        this.mainButton?.click();
      };

      handleViewportChange = () => {
        this.updateVisibility();
      };
    }
  );
}
